(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global['@leancode/validation'] = {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    function handleValidationErrors(validationErrors, command, validationResults) {
        if (validationResults === void 0) { validationResults = []; }
        var handle = function (validationErrorsToHandle, handler) {
            var result = undefined;
            var _loop_1 = function (validationErrorToHandle) {
                if (validationErrors.some(function (ve) { return ve.ErrorCode === command.ErrorCodes[validationErrorToHandle]; })) {
                    result = handler(validationErrorToHandle);
                    return "break";
                }
            };
            for (var _i = 0, _a = Array.isArray(validationErrorsToHandle)
                ? validationErrorsToHandle
                : [validationErrorsToHandle]; _i < _a.length; _i++) {
                var validationErrorToHandle = _a[_i];
                var state_1 = _loop_1(validationErrorToHandle);
                if (state_1 === "break")
                    break;
            }
            var nextResult = validationResults;
            if (result !== undefined) {
                nextResult = __spreadArrays(nextResult, [result]);
            }
            return handleValidationErrors(validationErrors, command, nextResult);
        };
        return {
            handle: handle,
            check: (function (reducer) {
                if (reducer) {
                    return validationResults.reduce(reducer.reducer, reducer.initialValue);
                }
            }),
        };
    }

    function handleResponse(response, command) {
        var newCommand = {
            ErrorCodes: __assign(__assign({}, command.ErrorCodes), { success: -1, failure: -2 }),
        };
        var validationErrors = response.isSuccess
            ? response.result.WasSuccessful
                ? [
                    {
                        AttemptedValue: "",
                        ErrorMessage: "",
                        PropertyName: "",
                        ErrorCode: -1,
                    },
                ]
                : response.result.ValidationErrors
            : [
                {
                    AttemptedValue: "",
                    ErrorMessage: "",
                    PropertyName: "",
                    ErrorCode: -2,
                },
            ];
        return handleValidationErrors(validationErrors, newCommand);
    }

    exports.handleResponse = handleResponse;
    exports.handleValidationErrors = handleValidationErrors;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
